import { useEffect, useState } from "react";

import Layout from "../Layout";
import { useUserContext } from "../contexts/UserContext";
import { nullUser } from "../contexts/reducers/userReducer";
import LoginScreen from "../pages/login/LoginScreen";
import { isNullOrEmpty } from "../utils/helper";

interface AuthAppGatewayProps {}

const AuthAppGateway = () => {
  const { user } = useUserContext();

  const [authorized, setAuthorized] = useState(false);

  const storedAccessToken = localStorage.getItem("accessToken");
  const storedRefreshToken = localStorage.getItem("refreshToken");

  // user Context has not been initialized yet but localstorage contains tokens - eg: on a page refresh
  const wasLoggedIn =
    !isNullOrEmpty(storedAccessToken) &&
    !isNullOrEmpty(storedRefreshToken) &&
    user === nullUser;

  //initial state is decided by whether the user was logged in before the page refresh
  //will be set to true when an error occurs when trying to refresh the Token
  const [newLoginRequired, setNewLoginRequired] = useState(!wasLoggedIn);

  //we use an event here because we need to wait for the apollo Client to have added the token to its requestHeaders
  //this is not the same as the token being set in AuthContext
  window.addEventListener("logInSuccessful", () => {
    setNewLoginRequired(false);
    setAuthorized(true);
  });

  window.addEventListener("logOut", () => {
    setNewLoginRequired(true);
    setAuthorized(false);
  });

  useEffect(() => {
    return () => {
      window.removeEventListener("logInSuccessful", () => {
        setNewLoginRequired(false);
        setAuthorized(true);
      });

      window.removeEventListener("logOut", () => {
        setNewLoginRequired(true);
        setAuthorized(false);
      });
    };
  }, []);

  if (newLoginRequired) return <LoginScreen />;

  return <Layout authorized={authorized} />;
};

export default AuthAppGateway;
